import type { ReactNode } from "react";

export function PageHeader({
  eyebrow,
  title,
  subtitle,
  children,
}: {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  children?: ReactNode;
}) {
  return (
    <header className="vault-masthead overflow-hidden rounded-lg p-6 text-white shadow-luxe sm:p-8 lg:p-10">
      <div className="grid gap-8 lg:grid-cols-[1.1fr_.9fr] lg:items-end">
        <div>
          {eyebrow && <p className="text-xs font-extrabold uppercase tracking-[0.24em] text-ktd-softGold">{eyebrow}</p>}
          <h1 className="mt-3 max-w-4xl text-balance font-display text-4xl font-bold leading-tight text-white sm:text-5xl">
            {title}
          </h1>
          {subtitle && <p className="mt-4 max-w-3xl text-base leading-7 text-white/68 sm:text-lg">{subtitle}</p>}
        </div>
        {children && <div>{children}</div>}
      </div>
    </header>
  );
}
